/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React, { useCallback, useContext, useMemo } from 'react';
import { FlowBlockLink as BlockModel } from '@staffino/model';
import { LinkBlock as BlockComponent } from '@staffino/flow-controls';
import { useFormContext } from 'react-hook-form';
import FlowContext from '../flow-context';
import { ConditionEvaluator } from '../condition-evaluator';
import useBridge from '../use-bridge-hook';
import usePropertyTranslation from '../use-property-translation-hook';

type Props = {
  block: BlockModel;
};

function LinkBlock({ block }: Props) {
  const bridge = useBridge();
  const form = useFormContext();

  const { definition, stateManager } = useContext(FlowContext);
  const evaluator = useMemo(
    () => new ConditionEvaluator(stateManager, bridge, definition, form),
    [stateManager, bridge, definition, form],
  );
  const handleClick = useCallback(
    () => evaluator.applyActions(block.actions ?? []),
    [evaluator, block],
  );
  const translatedText = usePropertyTranslation(
    block.translations,
    'text',
    block.text,
  );
  const translatedBlock = useMemo(
    () => ({ ...block, text: translatedText }),
    [block, translatedText],
  );
  return <BlockComponent block={translatedBlock} onClick={handleClick} />;
}

export default LinkBlock;
